import { useCallback, useState } from 'react'
import { Menu } from '@highlight/ui'
import { Plus } from 'lucide-react'
import { AttachmentMenuItems } from '@renderer/chat/components/chat/input/context/menu/attachments-menu'
import { FileAttachmentHandler } from '@renderer/chat/components/chat/input/context/file-attachment-handler'
import { useOnSidepanelHidden } from '@renderer/overlay/atoms'

/** The chat composer's attachments menu. It writes to the composer's shared state, so the chat the bar starts opens with it attached. */
export function SidebarAddMenu() {
  const [isOpen, setIsOpen] = useState(false)
  useOnSidepanelHidden(useCallback(() => setIsOpen(false), []))

  return (
    <>
      <Menu open={isOpen} onOpenChange={setIsOpen}>
        <Menu.Trigger variant="ghost" size="sm" shape="square" aria-label="Add to your question">
          <Plus />
        </Menu.Trigger>
        <Menu.Content align="start" sideOffset={8} className="w-fit">
          <AttachmentMenuItems />
        </Menu.Content>
      </Menu>
      <FileAttachmentHandler />
    </>
  )
}
